export default __webpack_public_path__ + "static/media/gallery_05.de26369e.jpg";